require('./$.species')(Array);


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es6.array.species.js
 ** module id = 88
 ** module chunks = 0
 **/